import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Box, Button, FormControl } from '@primer/react';

import { useCommonContext } from '../../../contexts/common';
import { ts_hocsinh_lichsu_yte_donvitinh } from '../../../models/response/category/ts_hocsinh_lichsu_yte_donvitinh';
import { donViTinhThuocApi } from '../../../api/donViTinhThuocApi';
import { NotifyHelper } from '../../../helpers/toast';
import Modal from '../../../components/ui/modal';
import TextInput from '../../../components/ui/text-input';
import Text from '../../../components/ui/text';

interface DonViTinhThuocEditModalProps {
    editingData?: ts_hocsinh_lichsu_yte_donvitinh;
    onSaveSuccess: () => void;
    onClose: () => void;
}

const DonViTinhThuocEditModal: React.FC<DonViTinhThuocEditModalProps> = ({ editingData, onSaveSuccess, onClose }) => {
    const { translate } = useCommonContext();
    const [isLoading, setIsLoading] = useState(false);

    const { register, handleSubmit, formState: { errors } } = useForm<ts_hocsinh_lichsu_yte_donvitinh>({
        defaultValues: editingData ? {
            ...editingData,
        } : {
            id: 0,
            ten_donvitinh: "",
            ten_donvitinh_en: "",
        }
    });

    const onSubmit = async (data: ts_hocsinh_lichsu_yte_donvitinh) => {
        try {
            setIsLoading(true);

            if (editingData) {
                await donViTinhThuocApi.update(data);
                NotifyHelper.Success("Cập nhật thành công");
            } else {
                await donViTinhThuocApi.insert(data);
                NotifyHelper.Success("Thêm mới thành công");
            }
            onSaveSuccess();
        } catch (error: any) {
            NotifyHelper.Error(error.message || "Có lỗi xảy ra");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            isOpen
            title={editingData ? "Base.Label.Edit" : "Base.Label.AddNew"}
            onClose={onClose}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box sx={{ display: "grid", gap: 2 }}>
                    <FormControl>
                        <FormControl.Label>
                            <Text text="Tên đơn vị tính" />
                        </FormControl.Label>
                        <TextInput
                            block
                            name="ten_donvitinh"
                            register={register}
                            errors={errors}
                            required
                            validateMessage={`${translate("Base.Form.RequiredMessage")} Tên đơn vị tính`}
                        />
                    </FormControl>

                    <FormControl>
                        <FormControl.Label>
                            <Text text="Tên đơn vị tính (EN)" />
                        </FormControl.Label>
                        <TextInput
                            block
                            name="ten_donvitinh_en"
                            register={register}
                            errors={errors}
                        />
                    </FormControl>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
                    <Button
                        type="button"
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        <Text text="Base.Label.Close" />
                    </Button>
                    <Button
                        type="submit"
                        variant="primary"
                        loading={isLoading}
                    >
                        <Text text="Base.Label.Save" />
                    </Button>
                </Box>
            </form>
        </Modal>
    );
};

export default DonViTinhThuocEditModal;
